
import { calculateSizeToFitElementInWrapper } from 'bits/attachments'
import window from 'bits/global'
import initPinchZoom from 'bits/pinchzoom'
import { Component, namespace, Prop, Vue, Watch } from 'bits/vue'
import ImageThumbnail from 'library/v4/components/ImageThumbnail.vue'
import debounce from 'lodash.debounce'

@Component({ components: { ImageThumbnail } })
export default class SurfacePanelPostExpandedAttachmentImage extends Vue {
  $refs!: {
    container: HTMLDivElement
  }
  @Prop({ required: true }) url!: string
  @Prop({ required: true }) originalImageUrl!: string
  @Prop({ required: true }) originalImageWidth!: number
  @Prop({ required: true }) originalImageHeight!: number
  @Prop({ required: true }) title!: string
  @namespace('postAction').Getter xExpandedPostTextPanel!: boolean

  width = 0
  height = 0
  aspectRatio = 0
  xBorderRadius = false

  @Watch('xExpandedPostTextPanel')
  setImageSize(): void {
    this.$nextTick(() => {
      const element = {
        width: this.originalImageWidth,
        height: this.originalImageHeight,
        aspectRatio: this.originalImageWidth / this.originalImageHeight,
      }
      const wrapper = {
        width: this.$refs.container.offsetWidth,
        height: this.$refs.container.offsetHeight,
      }
      const { width, height, isTouchingHorizontally, isTouchingVertically } = calculateSizeToFitElementInWrapper(
        element,
        wrapper,
      )
      this.width = width
      this.height = height
      this.aspectRatio = element.aspectRatio
      this.xBorderRadius = !isTouchingHorizontally && !isTouchingVertically
      this.$emit('resize', { width, height })
    })
  }

  debouncedSetImageSize = debounce(() => {
    if (window.visualViewport && window.visualViewport.scale > 1) {
      // When the content is pinch-zoomed, prevented any resizing and recalculation.
      // This is also done in other SurfacePanelPostExpandedAttachment[Type].vue components
      return
    }
    this.setImageSize()
  }, 250)

  deinitPinchZoom?: () => void
  mounted(): void {
    this.setImageSize()
    this.$nextTick(() => {
      this.deinitPinchZoom = initPinchZoom(this.$refs.container)
    })

    window.addEventListener('resize', this.debouncedSetImageSize)
  }

  beforeDestroy(): void {
    window.removeEventListener('resize', this.debouncedSetImageSize)
    this.deinitPinchZoom && this.deinitPinchZoom()
  }
}
